// extracted by mini-css-extract-plugin
export default {"emptyResults":"DomainWhitelistManager_emptyResults__4RjQX"};